var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91627 8.65209L9.44137 2.96032C9.56338 2.50497 9.31338 2.07196 8.85804 1.94995L3.16627 0.424847C2.71092 0.302839 2.27791 0.552839 2.1559 1.00818C2.03389 1.46352 2.28389 1.89654 2.73923 2.01854L6.42364 3.06678L0.938809 6.23345C0.505796 6.48345 0.383788 6.93879 0.633788 7.3718C0.883788 7.80481 1.33913 7.92682 1.77214 7.67682L7.25697 4.51016L6.2504 8.26673C6.12839 8.72207 6.37839 9.15508 6.83373 9.27709C7.28908 9.3991 7.79426 9.10743 7.91627 8.65209Z",
    fill: "#70707B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-arrow.0f112d922bf37da682b23e4a31130a43.svg";